import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";

import gnpVideos from "./gnp-videos.css";
import oVideosDatos from "./gnp-videos-datos";

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ "type": "VIDEO_SET_EVENT", "evento": evento});
		}
	};
};

class GnpVideosMenu extends React.Component {
	state = {
		showMenu: false,
		arrowIndex: 0,
		arrows: [
			require("../img/arrow-down.svg"),
			require("../img/arrow-up.svg")
		]
	}

	toggleMenu(e) {
		if (e != "menu") {
			if(e != false) {
				goTo("gnp/servicios-videos/" +  e.id);
				this.props.addEvento("Menu-"+e.menu);
			} else {
				goTo("/gnp/servicios-videos");
			}
			//this.props.toggle(e);
		};
		var arrowIndex = 0;
		if (this.state.arrowIndex == 0) {
			arrowIndex = 1;
		};
		this.setState({
			showMenu: !this.state.showMenu,
			arrowIndex: arrowIndex
		});
	}
	
	backArrow() {
		if (this.props.showDetalle) {
			this.props.toggle(false);
		} else {
			window.history.back();
		}
	}

	render() {
		return (
			<div className="gnp-videos">
				<div className="video-back">
					<img onClick={this.backArrow.bind(this)} src={ require("../img/video_volver.svg") }></img>
					<img className="mobil" onClick={this.backArrow.bind(this)} src={ require("../img/arrow_left.png") }></img>
				</div>
				<div className="menu-video">
					<a className="menu-video-a" onClick={this.toggleMenu.bind(this, "menu")}>Menú <img src={this.state.arrows[this.state.arrowIndex]}></img></a>
					<ul className={this.state.showMenu ? "": "hide"}>
						<li className="header" onClick={this.toggleMenu.bind(this,false)} >Videos</li>
						{ oVideosDatos.map((item,i) => {
							return <li key={i} onClick={this.toggleMenu.bind(this,item)} className={this.props.chosenVid == item.id ? "activo" : null}>{item.menu}</li>;
						})}
					</ul>
				</div>
			</div>
		);
	}
}

export default connect(null, mapDispatch)(GnpVideosMenu);


// WEBPACK FOOTER //
// ./src/gnp-servicios/gnp-videos-menu.cmpt.js